import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import InnerLoarder from './InnerLoarder';

export default function Loader({OpenLoader}) {

 
  
  
  return (
    <React.Fragment>
    
      <Dialog
        open={OpenLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
       
        <DialogContent>
         <div className='w-96'>
         <InnerLoarder/>
         <p className='text-center'>Powered By MastermindTech</p>
         </div>

        </DialogContent>
      
      </Dialog>
    </React.Fragment>
  );
}